<template>
  <div :style="{...styles.base}">
    <div :class="getCss('status-container')">
      <!-- 未报名 -->
      <div class="not_signed_up" v-show="isNoneSignPk">
        <div class="not_top">PK赛火热进行中</div>
        <img class="top_image" src="https://act.xinyue.qq.com/activity/tgclub/12080/bb824851440b36b5f279f701a6230b75.png">
        <div class="shortlisted">
          <ul class="shortlisted_ul">
            <li class="shortlisted_li1">5进3入围</li>
            <li class="shortlisted_li2">
              <img
                :src="configurationData.matchInIconImage"
              />
              <img
                :src="configurationData.matchInIconImage"
              />
              <img
                :src="configurationData.matchInIconImage"
              />
            </li>
            <li class="shortlisted_li3">
              <img
                :src="configurationData.matchOutIconImage"
              />
              <img
                :src="configurationData.matchOutIconImage"
              />
            </li>
          </ul>
          <ul class="shortlisted_ul2">
            <li class="shortlisted_ul2_li1">{{configurationData.signSuccessText}}</li>
            <li class="shortlisted_ul2_li2">
              <template v-for="(item, index) in configurationData.signMathGiftList">
                <div class="shortlisted_ul2_div" :key="`gift_icon${index}`">
                  <img
                    :src="item.iconImage"
                  />
                  <span>{{item.name}}</span>
                </div>
                <div class="shortlisted_ul2_div"
                     v-if="configurationData.signMathGiftList.length - 1 !== index"
                     :key="`gift_name${index}`">或
                </div>
              </template>
            </li>
          </ul>
          <c-button ref="signMatchActionButton"
                    :text="'立即报名'"
                    :style="{...signMatchActionButtonStyle}"
                    v-bind="$props"/>
        </div>
      </div>
      <!-- 已报名且不在休息日且没有淘汰、已報名已淘汰 每日榜单 -->
      <div v-show="isSignKnockInPk || isSignKnockOutPk">
        <div class="schedule">
          <div class="schedule_ul">
            <p class="schedule_li1">{{ weekInfo.title }}</p>
            <p class="schedule_li2">赛程</p>
          </div>
          <template v-for="(item, index) in weekInfo.weekDays">
            <div class="schedule_ul" :key="index" v-if="!item.isRest">
              <p :class="{
              'schedule_li1': true,
              'none-in-week': weekInfo.curWeek !== item.week
            }"
                 @click="clickMatchWeekHandel(item.week)"
              >
                {{item.date}}
              </p>
              <p :class="{
              'schedule_li2': true,
              'none-in-week': weekInfo.curWeek !== item.week
            }"
                 @click="clickMatchWeekHandel(item.week)"
              >
                {{item.name}}
              </p>
            </div>
          </template>
        </div>
        <div class="settlement">
          <template v-if="!isMatchEnd">
            <span class="settlement_left">距今日结算还剩</span>
            <span class="settlement_right">{{hours}}小时 {{minutes}}分 {{seconds}}秒</span>
          </template>
          <template v-if="isMatchEnd">
            <span class="match_end">单人赛本赛季已结束</span>
          </template>
        </div>
        <div class="ranking">
          <template v-for="( item,index ) in  upPartRankList">
            <ul class="ranking_ul" :key="index">
              <li class="ranking_li1">{{index + 1}}</li>
              <li class="ranking_li2">
                <img
                  :src="item.player && item.player.avatar ? item.player.avatar : defaultUserIcon"
                />
                <div class="ranking_li3">
                  <span>{{item.isValid ? '虚位以待' : item.player.nickname}}</span>
                  <span>
                  {{item.isValid ? '当前段位' : item.player.rank_level_text}}
                  {{!item.isValid ? ' | ' : ''}}
                  {{areaContent(item.player && item.player.plat_id ? item.player.plat_id : '' )}}
                </span>
                </div>
              </li>
              <li class="ranking_li4">{{  item.isValid ?  '--'  : item.total_score  ?  item.total_score : 0 }}分</li>
            </ul>
          </template>
          <ul class="ranking_ul2">
            <li></li>
            <li>每日排名前三名将会入围</li>
            <li></li>
          </ul>
          <template v-for="( item,index ) in  downPartRankList">
            <ul class="ranking_ul" :key="index+4">
              <li class="ranking_li1" style="color: #bdbdc8">{{index+4}}</li>
              <li class="ranking_li2">
                <img
                  :src="item.player && item.player.avatar ? item.player.avatar : defaultUserIcon"
                />
                <div class="ranking_li3">
                  <span>{{item.isValid ? '虚位以待' : item.player.nickname}}</span>
                  <span>
                  {{item.isValid ? '当前段位' : item.player.rank_level_text}}
                  {{!item.isValid ? ' | ' : ''}}
                  {{areaContent(item.player && item.player.plat_id ? item.player.plat_id : '' )}}
                </span>
                </div>
              </li>
              <li class="ranking_li4">{{  item.isValid ?  '--'  : item.total_score  ?  item.total_score : 0 }}分</li>
            </ul>
          </template>
        </div>
      </div>
      <!--已报名且不在周四休息日且没有淘汰-->
      <div v-show="isSignKnockInPk">
        <div
          :style="showDownLoadButton ? {} : callGameActionButtonEmptyStyle"
        >
          <c-button ref="callGameActionButton"
                    :text="'启动游戏'"
                    :style="{...callGameActionButtonStyle,display:showDownLoadButton ? 'static' :'none'}"
                    v-bind="$props"
          />
        </div>

        <div class="start_not_top_img">
          <ul class="not_top_img_ul">
            <li class="not_top_img_ul_li">
              <div class="not_top_img_ul_div">
                <img
                  src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/1.png"
                />
                <span v-html="configurationData.step1Text"></span>
                <img
                  src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230105105044.png"
                />
              </div>
              <div class="not_top_img_ul_div" style="width: 2.1rem">
                <img
                  src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/2.png"
                />
                <span v-html="configurationData.step2Text"></span>
                <img
                  src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230105105044.png"
                />
              </div>
              <div class="not_top_img_ul_div" style="width: 1.4rem">
                <img
                  src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/3.png"
                />
                <span v-html="configurationData.step3Text"></span>
              </div>
            </li>
            <li class="not_top_img_ul_li2"></li>
            <li class="not_top_img_ul_li3">{{configurationData.knockInStepText}}</li>
          </ul>
        </div>
      </div>
      <!-- 已报名且不在周四休息日且已经淘汰时 -->
      <div v-show="isSignKnockOutPk">
        <div class="resurrection">
          <ul class="resurrection_ul">
            <li class="resurrection_li1">
              <img
                src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230104102349.png"
              />
            </li>
            <div class="resurrection_li2">
              <span style="font-size: 0.28rem">复活急救包</span>
              <span style="font-size: 0.24rem; color: #8e8e93">当前拥有:{{packageRestNum}}</span>
            </div>
            <li class="resurrection_li3" :style="{...useRevivePackageButtonStyle}" @click="doUseRevivePackage" >使用</li>
          </ul>
          <ul class="resurrection_ul2">
            <li></li>
            <li style="font-size: 0.24rem; color: #8e8e93">获得复活急救包</li>
            <li></li>
          </ul>
          <ul class="resurrection_ul3">
            <li @click="joinGroupAction()">
              <img
                :src="!isEnabledJoinGroupGetPack ? 'https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Vector1.png'
                :' https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Vector.png'"
              />
              <p :style="{...joinGroupButtonStyle}">
                {{`加入社群获得(${!isEnabledJoinGroupGetPack ? 1 : 0}/1)`}}
              </p>
            </li>
            <li style="color: #8e8e93">|</li>
            <li  @click="callInviteFunc">
              <img
                src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Vector.png"
              />
              <p
                style="margin-left: 0.12rem">邀请好友获得({{inviteNum}})</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 已报名且在休息日 -->
      <div class="not_signed_up" v-show="isSignKnockRestPk">
        <div class="not_top">PK赛火热进行中</div>
        <img class="top_image" src="https://act.xinyue.qq.com/activity/tgclub/12080/f11eaac04b5a2d53746f81579aaf3ea9.png">
        <div class="shortlisted">
          <ul class="shortlisted_ul">
            <li class="shortlisted_li1">5进3入围</li>
            <li class="shortlisted_li2">
              <img
                :src="configurationData.matchInIconImage"
              />
              <img
                :src="configurationData.matchInIconImage"
              />
              <img
                :src="configurationData.matchInIconImage"
              />
            </li>
            <li class="shortlisted_li3">
              <img
                :src="configurationData.matchOutIconImage"
              />
              <img
                :src="configurationData.matchOutIconImage"
              />
            </li>
          </ul>
          <div class="registered">
            <div class="registered_div"></div>
            <ul class="registered_ul">
              <li style="font-size: 0.28rem; color: #b68950">你已报名</li>
              <li style="font-size: 0.24rem; color: #b68950">
                {{configurationData.signKnockRestTips1Text}}
              </li>
              <li style="font-size: 0.24rem; color: #b68950">
                {{configurationData.signKnockRestTips2Text}}
              </li>
            </ul>
          </div>
          <img
            class="sign-knock-rest-icon"
            src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/image317.png"
          />
        </div>
    </div>
    </div>
    <!--滚动显示报名按钮-->
    <div :class="getCss('register_now2')">
      <c-button ref="signMatchActionScrolleButton"
                :text="'立即报名'"
                :style="{...signMatchActionScrolleButtonStyle}"
                v-bind="$props"/>
      <p>{{configurationData.signMatchScrollTipsText}}</p>
    </div>

    <!--报名成功提示-->
    <c-base-dialog
      v-model="showSignSuccessPop"
      :option="showSignSuccessPopOption"
      @close="showSignSuccessPop = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('r-pop_ups')">
          <ul :class="getCss('pop_ups_ul')">
            <li>
              <img
                src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Signup.png"
              />
            </li>
            <li>报名成功</li>
            <li>欢迎来到和平精英单人PK赛</li>
            <li>在赛事页面中领取报名奖励哦~</li>
            <li @click="showSignSuccessPop = false">好的</li>
          </ul>
        </div>
      </template>
    </c-base-dialog>


    <!--改成报名二次提示-->
    <c-base-dialog
      v-model="firstAccessPageShowSignPop"
      :option="showFirstAccessPageShowSignPopOption"
      @close="closeFirstAccessPageShowSignPop"
      v-transfer-dom
    >
      <template slot="body">
        <div style="position: absolute">
          <div class="first-access-page-sign-guide">
            <img
              style="
          width: 1.98rem;
          height: 2.3rem;
          position: relative;
          top: -0.5rem;
          left: 1.8rem;
        "
              src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/2x4.png"
            />
          </div>
          <div
            @click="doSign"
            class="first-access-page-sign-Sign_up">立即报名</div>
        </div>

      </template>
    </c-base-dialog>


    <!--    成功领取复活包-->
    <c-base-dialog
      v-model="getRevivePackageSuccessDialog"
      :option="showUseRevivePackageSuccessOption"
      @close="getRevivePackageSuccessDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('r-pop-content')">
          <div :class="getCss('r-popTitle')">获得道具</div>
          <img
            src="https://game.gtimg.cn/images/js/img/tgclub/Framebox.png"
            alt=""
          />
          <span>复活急救包</span>
          <p>{{configurationData.getRevivePackageTip}}</p>
          <div :class="getCss('r-pop-btn')">
            <div :class="getCss('big-btn-grey')" @click="getRevivePackageSuccessDialog = false"> 我知道了 </div>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!--    成功领取复活包-->

    <!--    成功使用复活包的提示-->
    <c-base-dialog
      v-model="useRevivePackageSuccessDialog"
      :option="showUseRevivePackageSuccessOption"
      @close="useRevivePackageSuccessDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('r-pop-content')">
          <div :class="getCss('r-popTitle')">使用道具</div>
          <img
            src="https://game.gtimg.cn/images/tgclub/act/a20220829GameActivity/images1/img8.png"
            alt=""
          />
          <span>原地满血复活</span>
          <p>{{configurationData.successUsePackageTip}}</p>
          <div :class="getCss('r-pop-btn')">
            <div :class="getCss('big-btn-grey')" @click="useRevivePackageSuccessDialog = false"> 我知道了 </div>
          </div>
        </div>
      </template>
    </c-base-dialog>
    <!--    成功使用复活包的提示-->

    <!--    加群弹框-->
    <c-base-dialog
      v-model="showJoinGroupDialog"
      :option="showJoinGroupPopOption"
      @close="showJoinGroupDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <join-group
          :qqGroupLink="configurationData.qqGroupLink"
          :queryGroupListEnv="configurationData.queryGroupListEnv"
          :competitionId="configurationData.competitionId"
          :gid="configurationData.gid"
          :giftList="configurationData.joinGroupGiftList"
        >
        </join-group>
      </template>
    </c-base-dialog>
    <!--    加群弹框-->

    <!--    休息日弹窗-->
    <c-base-dialog
      v-model="showRestDayDialog"
      :option="showRestDayOption"
      @close="showRestDayDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('pop_ups')">
          <ul :class="getCss('pop_top')">
            <li>{{restDatePopTitle.title}}</li>
            <li>
              <img
                src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230104152120.png"
              />
              <span>{{restDatePopTitle.subTitle}}</span>
            </li>
          </ul>
          <p :class="getCss('pop-blank')"></p>
          <p :class="getCss('pop-more')">为你推荐更多</p>
          <join-group
            :qqGroupLink="configurationData.qqGroupLink"
            :queryGroupListEnv="configurationData.queryGroupListEnv"
            :competitionId="configurationData.competitionId"
            :gid="configurationData.gid"
            :giftList="configurationData.joinGroupGiftList"
          >
          </join-group>
        </div>
      </template>
    </c-base-dialog>
    <!--    休息日弹窗-->

    <!--    赛季结束弹窗-->
    <c-base-dialog
      v-model="showMatchEndDialog"
      :option="showMatchEndDialogOption"
      @close="showMatchEndDialog = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('pop_ups')">
          <ul :class="getCss('pop_top')">
            <li>单人PK赛本赛季已结束</li>
            <li>
              <span>下赛季再来吧</span>
            </li>
          </ul>
          <p :class="getCss('pop-blank')"></p>
          <p :class="getCss('pop-more')">为你推荐更多</p>
          <join-group
            :qqGroupLink="configurationData.qqGroupLink"
            :queryGroupListEnv="configurationData.queryGroupListEnv"
            :competitionId="configurationData.competitionId"
            :gid="configurationData.gid"
            :giftList="configurationData.joinGroupGiftList"
          >
          </join-group>
        </div>
      </template>
    </c-base-dialog>
    <!--    赛季结束弹窗-->
  </div>

</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { baseComponents, common, componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import { TgclubGameComponent } from '@tencent/ceiba-tgclub-base-components';
import JoinGroup from './JoinGroup.vue';

const NONE_SIGN_STATUS = 1;// 没有报名
const KNOCK_IN_STATUS = 2; //  已经报名且没有淘汰
const KNOCK_OUT_STATUS = 3; // 已经报名且淘汰
const KNOCK_REST_STATUS = 4; // 已经报名在休息日

export default {
  name: 'CTgclubCompetitionPkNewVersion',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    JoinGroup,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 't-match-pk-v-version-',
      listenId: '',
      gameInfo: {},
      pkMemberList: [],
      status: 1, // 1 没有报名   2 已经报名游戏  3 已经淘汰  4 已经报名在休息日
      // UseSavePackageStatus: 1, // 1 没有报名   2 已经报名游戏  3 已经淘汰
      showSignSuccessPop: false, // 报名成功弹框
      firstAccessPageShowSignPop: false, // 变成二次 报名二次确认
      isAccessFirstAccessPageShowSignPop: false, // 是否已经完成显示报名引导弹框
      isTriggerUserSignAction: false, // 是否已经触发完成 已一进入页面 完成报名相关操作
      // showInvitedDialog: false,
      showJoinGroupDialog: false,
      useRevivePackageSuccessDialog: false, // 成功使用复活包的提示
      // lackRevivePackageDialog: false, // 复活包不足的提示
      getRevivePackageSuccessDialog: false, // 成功获得复活包
      packageRestNum: 0, // 复活包数量
      inviteNum: 0, // 成功邀请其他人报名的参数
      joinGroupNum: 0, // 成功邀请其他人报名的参数
      inviteCode: '',
      // bgImage: '',
      // // 微信群跳转链接
      joinWxGroupLink: '',
      rankList: [], // 今日榜单数据
      hours: '00',
      minutes: '00',
      seconds: '00',
      timeId: null, // 每日榜单结束倒计时
      showRestDayDialog: false, // 休息日弹窗
      showMatchEndDialog: false, // 赛季结束弹窗
    };
  },
  computed: {
    showDownLoadButton() {
      // 合规版本不显示下载
      const isShowDownloadComponent = window.navigator.userAgent.toLowerCase().indexOf('islegalversion') === -1;
      console.log('合规版本不显示下载 res sShowDownloadComponent  =', isShowDownloadComponent);
      return isShowDownloadComponent;
    },
    isIOS() {
      return this.$platform.isIos;
    },
    // // 空头像时默认头像
    // emptyDefaultUserIcon() {
    //   return 'https://game.gtimg.cn/images/js/img/lottery/default_head.png';
    // },
    // // 内敛样式抹去按钮
    // buttonPureStyle() {
    //   return { position: 'relative', height: 'auto', width: 'auto', left: 0, top: 0 };
    // },
    // 是否有资格加群获得复活包
    isEnabledJoinGroupGetPack() {
      const { joinGroupGetPackageFlowId  = 0 } = this.configurationData;
      const packageStatus = this.quaInfo[joinGroupGetPackageFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    // 未报名
    isNoneSignPk() {
      return this.status === NONE_SIGN_STATUS;
    },
    //  没有淘汰
    isSignKnockInPk() {
      return this.status === KNOCK_IN_STATUS;
    },
    // 已经淘汰
    isSignKnockOutPk() {
      return this.status === KNOCK_OUT_STATUS;
    },
    // 已报名休息日
    isSignKnockRestPk() {
      return this.status === KNOCK_REST_STATUS;
    },
    // // 分享获复活包
    // isAccessShareGetPackage() {
    //   return  this.isEnabledJoinGroupGetPack  === false   &&  this.isSignKnockInPk;
    // },
    // // 加群获复活包
    // isAccessJoinGroupGetPackage() {
    //   return   this.isEnabledJoinGroupGetPack  === true   && (this.isSignKnockInPk || this.isSignKnockOutPk) ;
    // },
    // //  需要使用复活包
    // isOutAndNeedUsePackage() {
    //   return  this.isEnabledJoinGroupGetPack  === false &&  this.isSignKnockOutPk;
    // },
    // 成功领取复活包
    showUseRevivePackageSuccessOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        width: '7.5rem',
        height: '5.3rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    // 二次确认报名
    showFirstAccessPageShowSignPopOption() {
      return  {
        fotter: false,
        header: false,
        confirm: false,
        cancel: false,
        width: '5.7rem',
        height: '5.88rem',
        closeLocation: 'top-right',
        close: true,
        closeStyle: {
          backgroundImage: 'url(https://game.gtimg.cn/images/js/img/tgclub/signButtonClose.png)',
          top: '-1.0rem',
        },
        dialogStyle: {
          color: '#d7cdcd',
          fontSize: '0.28rem',
          borderRadius: '0.2rem',
          padding: '0 0',
          backgroundImage: 'url(https://game.gtimg.cn/images/tgclub/act/a20221124info/20230112/pop1.png)',
        },
        maskClickable: false,
      };
    },

    // 报名成功弹框
    showSignSuccessPopOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        width: '7.5rem',
        height: '5.3rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    showJoinGroupPopOption() {
      return  {
        fotter: true,
        header: '加入社群',
        confirm: false,
        cancel: false,
        close: true,

        positionType: 'bottom',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '5rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    showRestDayOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '7.92rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    showMatchEndDialogOption() {
      return  {
        fotter: true,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '7.92rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },
    // showUseRevivePackageSuccessOption() {
    //   return  {
    //     fotter: true,
    //     header: false,
    //     confirm: false,
    //     cancel: false,
    //     close: true,
    //     positionType: 'bottom',
    //     width: '7.5rem',
    //     height: '5.3rem',
    //     dialogStyle: {
    //       color: '#242424',
    //       fontSize: '0.28rem',
    //       padding: '0 0',
    //       overflow: 'hidden',
    //     },
    //     maskClickable: false,
    //   };
    // },
    // lackRevivePackagePopOption() {
    //   return  {
    //     fotter: true,
    //     header: false,
    //     confirm: false,
    //     cancel: false,
    //     close: true,
    //     positionType: 'bottom',
    //     width: '7.5rem',
    //     height: '4.1rem',
    //     dialogStyle: {
    //       color: '#242424',
    //       fontSize: '0.28rem',
    //       padding: '0 0',
    //       overflow: 'hidden',
    //     },
    //     maskClickable: true,
    //   };
    // },
    // pkMemberListRecord() {
    //   if (this.pkMemberList.length === 0) {
    //     return new Array(5).fill({ available: false });
    //   }
    //   if (this.pkMemberList.length ===  5) {
    //     return  this.pkMemberList;
    //   }
    //   return [...this.pkMemberList, ...new Array(5 - this.pkMemberList.length).fill({ available: false })];
    // },
    // // 获取复活急救包按钮样式
    // userSignButtonStyle() {
    //   return {
    //     backgroundColor: '#d7b386',
    //     color: '#ffffff',
    //     fontWeight: 500,
    //     width: '6.86rem',
    //     height: '0.8rem',
    //     fontSize: '0.32rem',
    //     borderRadius: '0.1rem',
    //     position: 'static',
    //     fontFamily: '微软雅黑',
    //   };
    // },
    signMatchActionButtonStyle() {
      return {
        width: '6.22rem',
        height: '0.8rem',
        color: '#fff',
        backgroundColor: '#d7b386',
        borderRadius: '0.12rem',
        fontSize: '0.32rem',
        lineHeight: '0.8rem',
        marginTop: '0.39rem',
        textAlign: 'center',
        position: 'static',
      };
    },
    signMatchActionScrolleButtonStyle() {
      return {
        width: '6.86rem',
        height: '0.8rem',
        backgroundColor: '#d7b386',
        borderRadius: '0.08rem',
        fontSize: ' 0.32rem',
        color: '#fff',
        lineHeight: '0.8rem',
        marginLeft: '0.32rem',
        textAlign: 'center',
        marginTop: '0.24rem',
        position: 'static',
      };
    },
    callGameActionButtonEmptyStyle() {
      return {
        width: '6.86rem',
        height: '0.8rem',
        marginTop: '0.24rem',
        position: 'static',
      };
    },
    callGameActionButtonStyle() {
      return {
        width: '6.86rem',
        height: '0.8rem',
        backgroundColor: '#d7b386',
        borderRadius: '0.12rem',
        marginTop: '0.24rem',
        position: 'static',
        fontSize: '0.32rem',
        textAlign: 'center',
        color: '#fff',
        lineHeight: '0.8rem',
      };
    },
    useRevivePackageButtonStyle() {
      return {
        backgroundColor: this.packageRestNum <= 0 ? '#f5f3f0' : '#D7B386',
        color: this.packageRestNum <= 0 ? '#d0d0d8' : '#FFFFFF',
      };
    },
    joinGroupButtonStyle() {
      return {
        marginLeft: '0.12rem',
        color: !this.isEnabledJoinGroupGetPack ? '#8e8e93' : 'inherit',
      };
    },
    // 是否赛季结束
    isMatchEnd() {
      const { weekList = [] } = this.configurationData;
      let isEnd = false;
      weekList.forEach((item) => {
        isEnd = new Date().getTime() >= new Date(item.endTime.replace(/-/g, '/')).getTime();
      });
      return isEnd;
    },
    weekInfo() {
      const { weekList = [], restWeekTime = [] } =  this.configurationData;
      const weekMapping = {
        0: '周日',
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
      };

      const getTime = function (time) {
        if (!time) return  '';
        const m = new Date(time).getMonth() + 1;
        const day = new Date(time).getDate();
        return `${m < 10 ? `0${m.toString()}` : m}.${day < 10 ? `0${day.toString()}` : day}`;
      };

      const weekDays = [];
      const curWeek = new Date().getDay();

      const weekInfo = weekList.find((item) => {
        const beginTimestamp = new Date(item.beginTime.replace(/-/g, '/')).getTime();
        const endTimestamp = new Date(item.endTime.replace(/-/g, '/')).getTime();
        const curTimestamp = new Date().getTime();
        return beginTimestamp <= curTimestamp && curTimestamp < endTimestamp;
      });
      if (!weekInfo) return { curWeek, weekDays };
      const beginTimestamp = new Date(weekInfo.beginTime.replace(/-/g, '/')).getTime();
      const endTimestamp = new Date(weekInfo.endTime.replace(/-/g, '/')).getTime();
      for (let i = 0; i <= 7; i++) {
        const timestamp = beginTimestamp + 24 * 60 * 60 * 1000 * i;
        if (timestamp >= endTimestamp) continue;
        const d = new Date(timestamp);
        // 休息日
        const isRest = restWeekTime && restWeekTime.map(num => parseInt(num, 10)).indexOf(d.getDay()) > -1;
        const week = d.getDay();
        const name = weekMapping[week];
        const date = getTime(timestamp);
        weekDays.push({ week, date, name, isRest });
      }
      console.log('weekInfo', { ...weekInfo, curWeek, weekDays });
      return {
        ...weekInfo,
        curWeek,
        weekDays,
      };
    },
    upPartRankList() {
      return  this.rankListRecord.slice(0, 3);
    },
    downPartRankList() {
      return  this.rankListRecord.slice(3, this.pageSize);
    },
    rankListRecord() {
      const num = this.pageSize - this.rankList.length;
      // 默认处理空头像
      const tempList = [...this.rankList].map((item)  => {
        if  (!item.player.avatar) {
          // eslint-disable-next-line no-param-reassign
          item.player.avatar =  'https://game.gtimg.cn/images/js/img/lottery/default_head.png';
        }
        return item;
      });
      if (num > 0) {
        return [...tempList, ...new Array(num).fill({ isValid: true })];
      }
      return  tempList;
    },
    pageSize() {
      return this.configurationData.pageSize || 5;
    },
    defaultUserIcon() {
      return this.configurationData.defaultUserIcon;
    },
    // roleId() {
    //   return this.roleInfo?.role_id;
    // },
    restDatePopTitle() {
      const title = `单人PK赛 | ${this.weekInfo.title}暂未开启`;
      const index = this.weekInfo.weekDays.findIndex(item => item.week === this.weekInfo.curWeek);
      const subTitle = `开启时间 ${index === this.weekInfo.weekDays.length - 1 ? '' : this.weekInfo.weekDays[index + 1].date}`;
      return { title, subTitle };
    },
    // 休息日弹窗资格
    isEnabledRestDayPopQua() {
      const { restDayPopQuaFlowId  = 0 } = this.configurationData;
      const packageStatus = this.quaInfo[restDayPopQuaFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    // 赛季结束弹窗资格
    isEnabledMatchEndPopQua() {
      const { mathcEndPopQuaFlowId  = 0 } = this.configurationData;
      const packageStatus = this.quaInfo[mathcEndPopQuaFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    accType() {
      return common.tool.getCookie('acctype');
    },
  },
  watch: {
    status: {
      handler(newVal) {
        if (newVal === KNOCK_IN_STATUS) {
          this.countDown();
          if (this.isLogin) {
            this.getTodayData();
          }
          return ;
        }
        if (newVal === KNOCK_OUT_STATUS) {
          if (this.isLogin) {
            this.getTodayData();
          }
          return ;
        }
        if (this.timeId) {
          clearInterval(this.timeId);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.timeId) {
      clearInterval(this.timeId);
    }
  },
  async mounted() {
    console.log('tgclub-user-pk-new-version configurationData=', this.configurationData);
    console.log('tgclub-user-pk-new-version this styles=', this.styles);
    await this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$isInEditor) return;
      this.listenBroadcastCheckRoleResult();
      // 监听状态
      this.initRemarkUserActStatus();
      // this.callJoinGroupGetRevivePackFunc();
      this.$onRoleReady(() => {
        this.queryPkInfo();
      });

      // this.$onQuaRefreshed(async () => {
      //   await this.showRestDatePop();
      //   await this.showMatchEndPop();
      // });
      this.$onLogined(() => {
        this.joinGroupFromApp();
      });
      this.scrollMatchButton();
      this.initButton();
    },
    initRemarkUserActStatus() {
      const getRandomId  = () => {
        const id = `${Math.random().toString(36)
          .slice(-10)}_${Math.floor(Math.random() * 10000000)}`;
        return `__temp_pk_new_lock_id_${id}`;
      };
      const randomKey =  getRandomId();
      this.listenId = randomKey;
      const that = this;
      const autoHandleTask = () => {
        let temp = {};
        Object.defineProperty(window, randomKey, {
          get() {
            return temp;
          },
          set: async (newValue) => {
            console.log('set = ', newValue);
            temp = newValue;
            if (newValue && Object.keys(newValue).length >= 2) {
              that.triggerUserSignAction(temp);
            }
          },
          enumerable: true,
          configurable: true,
        });
      };
      autoHandleTask();
    },
    async triggerUserSignAction(actionContent) {
      console.log('triggerUserSignAction =', actionContent);
      if (!actionContent) return  false;
      if  (typeof actionContent.isMatchSign  !== 'undefined'  &&  actionContent.isMatchSign === true && actionContent.isHasBindRole === true) {
        // let getPackViaJoinGroup = false;
        if (this.isEnabledJoinGroupGetPack) {
          console.log('triggerUserSignAction 查询成功加群给一次复活包');
          // getPackViaJoinGroup = await  this.queryGetRevivePackageFlow();
          this.queryGetRevivePackageFlow();
        }
        // if (common.tool.getQueryparams('getReviveByGroup') && this.$ast.isAPP() && getPackViaJoinGroup === false) {
        //   console.log('triggerUserSignAction 成功绑定角色并且 自动触发加群');
        //   this.showJoinGroupDialog = true;
        //   return;
        // }

        if (common.tool.getQueryparams('getReviveByInvite') && this.$ast.isAPP()) {
          console.log('triggerUserSignAction 成功绑定角色并且 自动触发加群分享');
          this.callInviteFunc();
          return;
        }

        if (common.tool.getQueryparams('signUp') && this.$ast.isAPP()) {
          console.log('triggerUserSignAction 成功绑定角色并且 自动触发报名成功弹窗');
          this.showSignSuccessPop = true;
          return;
        }

        return  true;
      }

      if (this.isTriggerUserSignAction === true) {
        return  false;
      }
      if  (typeof actionContent.isMatchSign  !== 'undefined'  &&  actionContent.isMatchSign === false) {
        this.isTriggerUserSignAction = true;
        if  (typeof actionContent.isHasBindRole  !== 'undefined'  && actionContent.isHasBindRole === false) {
          this.callBindRole();
          console.log('triggerUserSignAction 触发没有绑定角色 进行弹框');
          if (this.$refs.signMatchActionButton) {
            this.$onRoleReady(() => {
              if (this.isAccessFirstAccessPageShowSignPop === false) {
                this.firstAccessPageShowSignPop = true;
                this.isAccessFirstAccessPageShowSignPop = true;
              }
            });
          }
          return;
        }

        if (common.tool.getQueryparams('signUp') && this.$ast.isAPP()) {
          console.log('triggerUserSignAction 没有绑定角色 自动触发报名');
          if (this.$refs.signMatchActionButton) {
            this.$refs.signMatchActionButton.handleClick();
            return;
          }
        }
        // 触发引导报名
        this.firstAccessPageShowSignPop = true;
        return  true;
      }
    },
    closeFirstAccessPageShowSignPop() {
      this.firstAccessPageShowSignPop = false;
      this.isAccessFirstAccessPageShowSignPop = true;
    },
    callBindRole() {
      const self = this;
      try {
        baseComponents.gameRoleSelect.showGameRoleSelect(this.actInfo.game_code, {}).then((roleInfo) => {
          console.log('callBindRole store select role=', roleInfo);
          self.$store.dispatch('saveCurrentRole', {
            isRoleReady: true,
            roleInfo,
          });
        });
      } catch (e) {
        console.error('showGameRoleSelect fail| err=', e);
      }
    },
    // 是否已经报名角色  //  isMatchSign :  true,
    // 是否已经有角色    //  isHasBindRole : true
    // 是否首次进入页面   // isJoinGroup : true
    setRemarkUserActStatus(key, value) {
      const randomKey = this.listenId;
      console.log('---before window[randomKey]---', window[randomKey], randomKey);
      // if (Object.keys(window[randomKey]).length >= 2) return;
      window[randomKey] = {
        ...window[randomKey],
        [key]: value,
      };
      console.log('---after window[randomKey]---', window[randomKey], randomKey);
    },
    // //  同步pk信息 是否被淘汰
    // syncPkStatusNum(status) {
    //   this.$eventBus.$emit('ceiba:custom:events:call:sync:pk:status', { status  });
    // },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    listenBroadcastCheckRoleResult() {
      this.$eventBus.$on('ceiba:custom:events:broadcast:check:role:result', async ({ roleInfo }) => {
        console.log('listenBroadcastCheckRoleResult roleInfo = ', roleInfo);
        if  (roleInfo.role_id) {
          this.setRemarkUserActStatus('isHasBindRole', true);
        } else {
          this.setRemarkUserActStatus('isHasBindRole', false);
          this.setRemarkUserActStatus('isMatchSign', false);
        }
      });
    },
    async joinWxGroupFunc() {
      if (!this.joinWxGroupLink) await this.queryGroupQrCodeList();
      this.reportFunc('open_url', { url: this.joinWxGroupLink });
      this.reportFlush();
      await  this.doSleep(500);
      this.$ast.openView({ url: this.joinWxGroupLink });
    },
    async joinQQGroupFunc() {
      const { qqGroupLink } = this.configurationData;
      if (qqGroupLink) {
        this.reportFunc('open_url', { url: qqGroupLink });
        this.reportFlush();
        await  this.doSleep(500);
        this.$ast.openView({ url: qqGroupLink });
      }
    },
    initButton() {
      const { forceAppSign = false } = this.configurationData;
      // 报名
      // 如果直接点击不进行 二次确认
      if (this.$refs.signMatchActionButton) {
        this.$refs.signMatchActionButton.setClickHandler(this.doSign, {
          forceApp: forceAppSign,
          forceLogin: true,
          forceRole: false,
        });
      }
      // 如果直接点击不进行 二次确认
      if (this.$refs.signMatchActionScrolleButton) {
        this.$refs.signMatchActionScrolleButton.setClickHandler(this.doSign, {
          forceApp: forceAppSign,
          forceLogin: true,
          forceRole: false,
        });
      }

      if  (this.$refs.callGameActionButton) {
        this.$refs.callGameActionButton.setClickHandler(this.callGame, {
          forceApp: true,
          forceLogin: true,
          forceRole: true,
        });
      }

      // // 使用复活包
      // this.$refs.reviveUserButton.setClickHandler(this.doUseRevivePackage, {
      //   forceApp: forceAppUsePackage,
      //   forceLogin: false,
      //   forceRole: false,
      // });
      //
      // // 加群
      // this.$refs.JoinWxQQGroupButton.setClickHandler(this.joinGroupAction, {
      //   forceApp: false,
      //   forceLogin: true,
      //   forceRole: true,
      // });
      // console.log('this.$refs.shareUserButton1 ', this.$refs.shareUserButton1);
      // if  (this.$refs.shareUserButton1) {
      //   this.$refs.shareUserButton1.setClickHandler(this.callInviteFunc, {
      //     forceApp: forceAppShare,
      //     forceLogin: true,
      //     forceRole: true,
      //   });
      // }
      // if  (this.$refs.shareUserButton2) {
      //   this.$refs.shareUserButton2.setClickHandler(this.callInviteFunc, {
      //     forceApp: forceAppShare,
      //     forceLogin: true,
      //     forceRole: true,
      //   });
      // }
    },
    // callJoinGroupGetRevivePackFunc() {
    //   const that = this;
    //   const  getRandomId = () => {
    //     const id = `${Math.random().toString(36)
    //       .slice(-10)}_${Math.floor(Math.random() * 10000000)}`;
    //     return `__temp_revive_lock_id_${id}`;
    //   };
    //   const randomKey = getRandomId();
    //   const autoHandleTask = () => {
    //     let temp = {};
    //     Object.defineProperty(window, randomKey, {
    //       get() {
    //         return temp;
    //       },
    //       set: async (newValue) => {
    //         console.log('set = ', newValue);
    //         temp = newValue;
    //         if (newValue && Object.keys(newValue).length >= 2) {
    //           //  请求是否 可以加群获得 复活包
    //           that.queryGetRevivePackageFlow();
    //           // 已解锁
    //         }
    //       },
    //       enumerable: true,
    //       configurable: true,
    //     });
    //   };
    //   autoHandleTask();
    //   const setLockForceRoleFunc = (key) => {
    //     console.log('window[randomKey]', window[randomKey], randomKey);
    //     // if (Object.keys(window[randomKey]).length >= 2) return;
    //     window[randomKey] = {
    //       ...window[randomKey],
    //       [key]: 1,
    //     };
    //     console.log('window[randomKey]', window[randomKey], randomKey);
    //   };
    //   this.$onRoleReady(async () => {
    //     setLockForceRoleFunc('onCheckLockRoleReadyRevivePackage');
    //   });
    //
    //   this.$onQuaRefreshed(async () => {
    //     if (!that.isEnabledJoinGroupGetPack) {
    //       console.warn('不需要触发 加群获 复活包的流程 isEnabledJoinGroupGetPack =', that.isEnabledJoinGroupGetPack);
    //       return;
    //     }
    //     setLockForceRoleFunc('onCheckLockQuaRefreshedRevivePackage');
    //   });
    // },
    // 通过加群获得一个复活包
    async queryGetRevivePackageFlow() {
      if (!this.isEnabledJoinGroupGetPack) return  false;
      const { joinGroupGetPackageFlowId } = this.configurationData;
      if (joinGroupGetPackageFlowId  <= 0) {
        return  false;
      }
      const response = await this.flowRequest({
        flowId: joinGroupGetPackageFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('queryGetRevivePackageFlow = response = ', response);
      const { ret, data = {} } = response;
      if (ret !== 0)  {
        // this.queryGroupQrCodeList();
        return false;
      }
      const { ret: resRet } = data;
      if (resRet !== 0)  {
        // this.queryGroupQrCodeList();
        return false;
      }
      this.getRevivePackageSuccessDialog = true;
      this.queryPkInfo();
      return  true;
    },
    // // 没有道具
    // handleClickLackRevivePackage() {
    //   const {  forceAppShare = true } = this.configurationData;
    //
    //   this.lackRevivePackageDialog = true;
    //   this.$nextTick(() => {
    //     this.$refs.shareUserButtonPop.setClickHandler(this.callInviteFunc, {
    //       forceApp: forceAppShare,
    //       forceLogin: true,
    //       forceRole: true,
    //     });
    //   });
    // },
    // 使用复活包
    async doUseRevivePackage() {
      this.handleClickEvent();
      const { forceAppUsePackage = false } = this.configurationData;
      if (forceAppUsePackage) {
        return  this.$ast.gotoAPP();
      }
      console.log('access use useRevivePackage  call  复活包 num', this.packageRestNum);
      const {  useRevivePackageFlowId } = this.configurationData;
      if (useRevivePackageFlowId <= 0) return;
      if (this.packageRestNum <= 0) {
        // return   this.handleClickLackRevivePackage();
        this.$toast('先去获得复活包吧～');
        return true;
      }
      try {
        console.log('check do  useRevivePackage 使用复活包  request=', useRevivePackageFlowId, this.roleInfo);
        const response = await this.flowRequest({
          flowId: useRevivePackageFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('check do useRevivePackage response=', response);
        const { ret, msg, data = {} } = response;
        if (ret !== 0)  {
          this.$alert({ msg });
          return true;
        }
        const { ret: resRet, msg: resMsg } = data;
        if (resRet !== 0)  {
          this.$alert({ msg: resMsg || '操作失败' });
          return true;
        }
        this.queryPkInfo();
        this.useRevivePackageSuccessDialog = true;
        return true;
      } catch (e) {
        console.log('check do sign fail,er=', e);
      }
    },

    async callInviteFunc() {
      this.handleClickEvent();
      const { forceAppShare = false } = this.configurationData;
      if (forceAppShare === true && !this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return;
      }
      if (!this.isLogin) {
        this.$alert({ msg: '请先登录' });
        return false;
      }
      const { role_id: roleId } = this.roleInfo;
      if (!roleId) {
        this.$toast('请先绑定角色在分享操作');
        this.callBindRole();
        return  false;
      }
      if (!this.inviteCode) {
        const params = {
          business: this.$actInfo.ast,
          activity: `${this.$actInfo.activity_id}`,
          ext: JSON.stringify({
            name: this.userInfo.nickName,
            avatar: this.userInfo.avatar || 'https://game.gtimg.cn/images/js/img/lottery/default_head.png',
            shareRoleId: roleId,
          }),
        };
        console.log('getInviteCode', this.userInfo, params);
        const response =  await  baseComponents.Apis.User.getInviteCode(params);
        console.log('getInviteCode response = ', response);
        const { data = {}  } = response || {};
        const { invite_code: inviteCode = '' } = data;
        if (!inviteCode) {
          this.toast('获取邀请码失败');
          this.inviteCode = '';
          return false;
        }

        this.inviteCode = inviteCode;
      }
      let link = common.tool.setUrlParam(
        'c_invite_code', this.inviteCode,
        this.configurationData.link ||  this.shareConfig.link || window.location.href,
      );
      link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
      const shareNewConfig = {
        title: this.configurationData.title ||  this.shareConfig.title,
        link,
        desc: this.configurationData.desc || this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
        icon: this.configurationData.icon || this.shareConfig.icon, // 分享后朋友看到的图标
      };
      this.reportFunc('share', {});
      // this.lackRevivePackageDialog = false;
      if (this.$ast.isAPP()) {
        this.$ast.setAPPShare(shareNewConfig);
        this.$ast.goAPPShare();
      } else {
        this.doShare(shareNewConfig);
      }
    },
    // 查询微信加群链接
    async queryGroupQrCodeList() {
      const { queryGroupListEnv = 'prod', gid, competitionId } = this.configurationData;
      let url = '';
      if (queryGroupListEnv === 'prod') {
        url = 'https://bgw.xinyue.qq.com/xyapp.CompetitionSrv/GetChatUrlList';
      } else {
        url = 'https://bgw-t.xinyue.qq.com/xyapp.CompetitionSrv/GetChatUrlList';
      }
      const response = await this.$requestInstance.post(url, { gid, competition_id: competitionId });
      console.log('queryGroupQrCodeList response =',  response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg: msg || '获取微信二维码失败' });
      }
      const { list = [] } = data;
      if (!list || list.length === 0) {
        return this.$alert({ msg: '获取微信二维码失败!' });
      }
      this.joinWxGroupLink = list[0]?.url  ?? '';
    },
    // 加入群
    joinGroupAction() {
      this.handleClickEvent();
      if (!this.isEnabledJoinGroupGetPack) {
        this.$toast('你已通过加入社群获得过复活包');
        return false;
      }
      if (this.accType === 'wx') this.joinWxGroupFunc();
      if (this.accType !== 'wx') this.joinQQGroupFunc();
    },
    joinGroupFromApp() {
      if (common.tool.getQueryparams('getReviveByGroup') && this.$ast.isAPP()) {
        if (this.accType === 'wx') this.joinWxGroupFunc();
        if (this.accType !== 'wx') this.joinQQGroupFunc();
      }
    },
    // 请求流程报名
    async  doSign() {
      this.handleClickEvent();
      if  (!this.isNoneSignPk) {
        return;
      }
      const { doSignFlowId } = this.configurationData;
      if (doSignFlowId <= 0) return;
      const { role_id: roleId } = this.roleInfo;
      if (!roleId) {
        this.callBindRole();
        this.$onRoleReady(() => {
          this.doSign();
        });
        return  false;
      }
      try {
        console.log('check do  sign request=', doSignFlowId, this.roleInfo);
        const response = await this.flowRequest({
          flowId: doSignFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('check do sign response=', response);
        const { ret, msg, data } = response;
        if (ret !== 0)  {
          this.reportFunc('sign_up', { status: '0' });
          this.$alert({ msg });
          return true;
        }
        const { ret: resRet, msg: RetMsg } = data;
        if (resRet !== 0)  {
          this.reportFunc('sign_up', { status: '0' });
          this.$alert({ msg: RetMsg || '赛事报名失败'  });
          return true;
        }
        this.reportFunc('sign_up', { status: '1' });
        this.queryPkInfo();
        this.refreshQua(); // 刷新礼包
        this.firstAccessPageShowSignPop = false;
        this.showSignSuccessPop = true;
        return true;
      } catch (e) {
        console.log('check do sign fail,er=', e);
      }
    },
    // 查询PK信息
    async  queryPkInfo() {
      // 已解锁
      const { checkPkInfoFlowId, restWeekTime = [] } = this.configurationData;
      if (checkPkInfoFlowId <= 0) return;
      console.log('check user pk request=', checkPkInfoFlowId, this.roleInfo);
      try {
        const response = await this.flowRequest({
          flowId: checkPkInfoFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('check user match pk response=', response);
        const { ret, msg, data = {} } = response;
        if (ret !== 0)  {
          this.$alert({ msg: msg || '获取pk信息失败' });
          return false;
        }
        const { info = '{}', ret: resRet, inviteNum = 0  }  = data;
        if (resRet !== 0) {
          this.setRemarkUserActStatus('isMatchSign', false);
          this.$alert({ msg: '获取pk信息失败' });
          return  false;
        }
        const dataInfo = info ?  JSON.parse(info) : {};
        console.log('this.styles in Tgclub-user-pk info', dataInfo);
        const { ret: infoRet, msg: infoMsg,
          is_signed: isSigned, is_knockout: isKnockout, match_player_list: matchPlayerList = [],
          remain_revive_num: remainReviveNum = 0 } = dataInfo;
        if (infoRet !== 0) {
          this.setRemarkUserActStatus('isMatchSign', false);
          this.$alert({ msg: infoMsg || '获取pk信息失败' });
          return  false;
        }

        // 剩余的复活包数量
        this.packageRestNum = remainReviveNum;
        this.inviteNum = inviteNum;
        if (isSigned !== true) {
          // 没有报名
          this.setRemarkUserActStatus('isMatchSign', false);
          this.status = NONE_SIGN_STATUS;
          return  false;
        }
        this.setRemarkUserActStatus('isMatchSign', true);
        if (restWeekTime && restWeekTime.map(num => parseInt(num, 10)).indexOf(new Date().getDay()) > -1) {
          // 休息日
          this.status = KNOCK_REST_STATUS;
        } else {
          // 已报名已入围、已报名已淘汰
          this.status = isKnockout ? KNOCK_OUT_STATUS : KNOCK_IN_STATUS;
        }
        // this.syncPkStatusNum(this.status);
        this.pkMemberList = matchPlayerList;
      } catch (e) {
        console.log('check user match sign fail,er=', e);
      }
      return false;
    },
    // // 休息日弹窗
    // async showRestDatePop() {
    //   const {  restWeekTime = [], restDayPopQuaFlowId } = this.configurationData;
    //   if (restWeekTime.length === 0)   return false;
    //   if (!this.isEnabledRestDayPopQua) return false;
    //
    //   // 是否休息日
    //   const isRest = restWeekTime && restWeekTime.map(num => parseInt(num, 10)).indexOf(new Date().getDay()) > -1;
    //   if (!isRest) return false;
    //
    //   const response = await this.flowRequest({
    //     flowId: restDayPopQuaFlowId,
    //     params: {
    //       role: this.roleInfo,
    //     },
    //   });
    //   console.log('queryRestDayPopQuaFlow = response = ', response);
    //   const { ret, data = {} } = response;
    //   if (ret !== 0)  {
    //     return false;
    //   }
    //   const { ret: resRet } = data;
    //   if (resRet !== 0)  {
    //     return false;
    //   }
    //   this.showRestDayDialog = true;
    // },
    // // 赛季结束弹窗
    // async showMatchEndPop() {
    //   const { mathcEndPopQuaFlowId, weekList = [] } = this.configurationData;
    //   if (!this.isEnabledMatchEndPopQua) return false;
    //
    //   // 是否赛季结束
    //   let isEnd = false;
    //   weekList.forEach((item) => {
    //     isEnd = new Date().getTime() >= new Date(item.endTime.replace(/-/g, '/')).getTime();
    //   });
    //   if (!isEnd) return false;
    //
    //   const response = await this.flowRequest({
    //     flowId: mathcEndPopQuaFlowId,
    //     params: {
    //       role: this.roleInfo,
    //     },
    //   });
    //   console.log('queryMatchEndPopQuaFlow = response = ', response);
    //   const { ret, data = {} } = response;
    //   if (ret !== 0)  {
    //     return false;
    //   }
    //   const { ret: resRet } = data;
    //   if (resRet !== 0)  {
    //     return false;
    //   }
    //   this.showMatchEndDialog = true;
    // },
    clickMatchWeekHandel(week) {
      if (!this.isLogin) return;
      const { matchNoStarTipsText, matchEndTipsText } = this.configurationData;
      const { curWeek, weekDays } = this.weekInfo;
      const weekIndex = weekDays.findIndex(item => item.week === week);
      const curWeekIndex = weekDays.findIndex(item => item.week === curWeek);
      if (curWeekIndex < weekIndex) this.toast(matchNoStarTipsText);
      if (curWeekIndex > weekIndex) this.toast(matchEndTipsText);
    },
    // 查询今日榜单
    async getTodayData() {
      const { queryRankListFlowId } = this.configurationData;
      if (queryRankListFlowId <= 0) return;
      this.doSleep(1000);
      const response = await this.flowRequest({
        flowId: queryRankListFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            page: 1,
            pageSize: this.pageSize,
          }),
        },
      });
      console.log('data------- today record ,queryRankListFlowId', queryRankListFlowId, response);
      const { ret, msg, data }  = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '获取今日战绩失败' });
        return;
      }
      const { info  = '', ret: retRet } = data;
      if (retRet !== 0) {
        this.$alert({ msg: '获取今日战绩失败' });
        return;
      }
      const infoData = info ? JSON.parse(info) : {};

      const { ret: finalRet,  msg: finalMsg, list = [] } = infoData;
      if (finalRet !== 0) {
        this.$alert({ msg: finalMsg || '获取今日战绩失败' });
        return;
      }
      console.log('list =  today record today pk info list ', list);
      // game_roleid
      // console.log('list =  today record today pk info myself ', myself);
      this.rankList = list || [];
      // this.myself = myself || {};
    },
    areaContent(platId) {
      // eslint-disable-next-line no-param-reassign
      platId  = parseInt(platId, 10);
      const obj =  {
        0: 'ios',
        1: '安卓',
        2: '游客',
      };
      return obj[platId] ? obj[platId] : '';
    },
    // 今日榜单结算倒计时
    countDown() {
      //  当前时间局域
      const that  = this;
      let { countDownTime = '23:00:00' } = this.configurationData;
      countDownTime = countDownTime ? countDownTime : '23:00:00';
      // 当天时间抽
      this.timeId = setInterval(() => {
        const  date = new Date();
        const now = parseInt(date.getTime() / 1000, 10);
        // 设置截止时间
        const endDate = new Date(`${date.toLocaleDateString()} ${countDownTime}`);
        const end = parseInt(endDate.getTime() / 1000, 10);
        // 时间差
        let  leftTime = end - now;
        leftTime = leftTime > 0 ? leftTime : leftTime + 24 * 3600 ;
        // 定义变量 d,h,m,s保存倒计时的时间
        if (leftTime >= 0) {
          // eslint-disable-next-line no-mixed-operators
          const  hours = Math.floor(leftTime   / 60 / 60 % 24);
          that.hours = hours >= 10 ? hours.toString() : `0${hours}`  ;
          // eslint-disable-next-line no-mixed-operators
          const  minutes = Math.floor(leftTime  / 60 % 60);
          that.minutes = minutes >= 10 ? minutes.toString() : `0${minutes}`  ;
          // eslint-disable-next-line no-mixed-operators
          const  seconds = Math.floor(leftTime  % 60);
          that.seconds = seconds >= 10 ? seconds.toString() : `0${seconds}`  ;
        } else {
          that.hours = '00';
          that.minutes = '00';
          that.minutes = '00';
          clearInterval(that.timeId);
        }
      }, 1000);
    },
    // 拉起游戏
    async callGame() {
      const gameInfo = await TgclubGameComponent.getGameInfoData(1279);
      console.log('---callGameRes----', gameInfo);
      const callGameParams = { isNeedDownload: true, targetGameInfo: gameInfo };
      const callGameRes = await TgclubGameComponent.callAndDownLoadGame(callGameParams);
      console.log('---callGameRes----', callGameRes);
      this.reportFunc('launch_game', {
        game_code: this.$actInfo?.game_code,
        status: callGameRes ? '1' : '0',
      });
      const reportDownLoadFunc = (status, gameInfo) => {
        if (typeof this.reportClickRaw === 'function') {
          const params = {
            ceibaComponentId: `${this.cid}`,
            ceibaComponentUid: this.uid,
            ceibaComponentUname: this.uname,
            eventKey: 'download',
            eventData: {
              packagename: this.isIOS ? gameInfo.iOSPkgName : gameInfo.packagename,
              game_code: this.$actInfo?.game_code ?? '',
              status,
              dversion: gameInfo.version,
              gchannelversion: gameInfo.channelid,
              apkchannel: gameInfo.channelid,
            },
          };
          this.reportClickRaw(params);
          console.log('reportFunc download data =', params);
        }
      };
      if (callGameRes && this.isIOS) {
        // ios 下载上报一次 下载和拉起
        reportDownLoadFunc('1', gameInfo);
      }
      if (!callGameRes) {
        // 安卓下载上报
        reportDownLoadFunc('1', gameInfo);
      }
    },
    scrollMatchButton() {
      const that = this;
      window.onscroll = function () {
        const topScroll = document.documentElement.scrollTop || document.body.scrollTop;// 滚动的距离,距离顶部的距离
        const bignav = document.querySelector(`.${that.getCss('register_now2')}`);// 获取到导航栏id
        if (!that.isNoneSignPk) {
          bignav.style.position = 'static';
          bignav.style.display = 'none';
          return false;
        }
        if (topScroll <= 740) {
          // 当滚动距离小于250的时候执行下面的内容，也就是让导航栏恢复原状
          bignav.style.display = 'none';
          bignav.style.position = 'static';
        } else {
          // 当滚动距离大于250px时执行下面的东西
          bignav.style.display = 'block';
          bignav.style.zIndex = '100';
          bignav.style.position = 'fixed';
          bignav.style.bottom = '0';
          console.log(topScroll);
        }
      };
    },
    reportFunc(key, obj) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
        console.log('reportFunc sign_up data =', params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
